
import lottie from 'lottie-web';
export default {
  props: ['error'],
  computed: {
    /**
     * @description 判断消息类型
     * @returns { String } 消息类型
     */
    messageType() {
      return typeof this.error.message;
    },
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('404-gif'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/svg-icon/404-img.json',
    });
  },
  methods: {
    reload() {
      location.reload();
    },
  },
};
